<template>
  <form
    id="auth-form"
    ref="containerBlock"
    class="form-controls"
    :class="{ _mobile: isMobile }"
    @submit.prevent="validate"
  >
    <div
      v-if="isVisibleBonus || isVisibleEmailNotification"
      class="form-controls__success"
    >
      <icon
        name="Success_52"
        class="form-controls__success-icon"
        width="52"
        height="52"
      />

      <p
        v-if="isMobile"
        :class="titleMobileClass"
        v-html="title"
      >
      </p>
    </div>

    <div
      v-if="showTitle"
      :class="titleClass"
      v-html="title"
    >
    </div>

    <div
      v-if="isRegistration"
      class="form-controls__subtitle _mobile"
    >
      Присоединяйтесь к нашему сообществу любителей книг,
      копите бонусные рубли и оплачивайте ими до 99% от стоимости заказа
    </div>

    <div class="form-controls__container">
      <form-item v-if="notify.caption" class="_mt">
        <notify ref="notifyBlock" :type="notify.type">
          {{ notify.caption }}
          <div v-if="isPhoneExist">
            <button
              class="form-controls__link _notify"
              type="button"
              tabindex="5"
              @click.prevent="alertRecoverPassClickEvent"
            >
              Восстановить пароль
            </button>
          </div>
        </notify>
      </form-item>

      <div v-if="state === 'forgot'" class="form-controls__item _desc _mt">
        {{ forgotText }}
      </div>

      <form-item
        v-if="!isRegistrationSuccess && !isConfirmRecovery"
        v-bind="fieldValidation('email')"
        label="Электронная почта"
        :is-gray-label="true"
        :class="{_mt: state !== 'forgot'}"
      >
        <input-control
          v-model.trim="email"
          name="email"
          inputmode="email"
          autocomplete="on"
          :tabindex="1"
          :loading="isEmailChecking"
          @input="handlerInputEmail"
        />
      </form-item>

      <template v-if="state === 'login'">
        <form-item
          v-bind="fieldValidation('password')"
          label="Введите пароль"
          :show-password="true"
          :is-gray-label="true"
        >
          <input-control
            v-model.trim="password"
            name="password"
            autocomplete="on"
            :tabindex="3"
          />
        </form-item>
        <form-item class="_desc _center">
          <button
            class="form-controls__link"
            type="button"
            tabindex="5"
            @click.prevent="changeState('forgot')"
          >
            Забыли пароль?
          </button>
        </form-item>
        <div
          ref="recaptchaContainer"
          :class="{'b24-form-item': recaptchaWidget !== null}"
        ></div>
        <form-item class="_desc _center">
          <button-control
            size="large"
            native-type="submit"
            :tabindex="4"
            :loading="loading"
            :disabled="loading"
            :is-block="true"
          >
            Войти
          </button-control>
        </form-item>

        <form-item class="_desc _center _no-mb">
          Нет аккаунта?
          <button
            type="button"
            class="form-controls__link"
            tabindex="1"
            @click.prevent="changeState('registration', true)"
          >
            Зарегистрируйтесь
          </button>
        </form-item>
      </template>

      <template v-if="state === 'registration'">
        <form-item
          v-bind="fieldValidation('name')"
          label="ФИО"
          :is-gray-label="true"
        >
          <input-control
            v-model.trim="name"
            placeholder="Фамилия Имя Отчество"
            name="userName"
            autocomplete="off"
            :tabindex="2"
            :name-builder="true"
          />
        </form-item>
        <form-item
          v-bind="fieldValidation('phone')"
          label="Номер телефона"
          :is-gray-label="true"
        >
          <input-phone-control
            v-model.trim="phone"
            name="userPhone"
            autocomplete="off"
            :tabindex="3"
            :is-masked="isRus"
          />
        </form-item>
        <sms-confirm
          v-if="needProof"
          ref="smsConfirm"
          class="_d form-controls__sms-confirm"
          :phone="phone"
          :show-button-send="false"
          :is-use-new-end-point="true"
          :captcha-options="captchaOptions"
          :captcha-options-v2="captchaOptionsV2"
          @error="catchError"
          @incorrectPhone="incorrectPhone"
          @updateCaptchaV3="generateCaptcha"
          @verified="handlerVerified"
        />
        <div
          ref="recaptchaContainer"
          :class="{'b24-form-item': recaptchaWidget !== null}"
          class="form-controls__recaptcha"
        ></div>
        <form-item>
          <checkbox-control v-model="isAgreeWithData" :model-value="true">
            <checkbox-policy-text class="_long-text">
              Я согласен получать рекламные сообщения
            </checkbox-policy-text>
          </checkbox-control>
        </form-item>
        <form-item
          :text-error="!isAgreeWithRules ? errorTextPolicy: ''"
        >
          <checkbox-control v-model="isAgreeWithRules" :model-value="true">
            <checkbox-policy-text class="_long-text">
              Я принимаю условия
              <a class="form-controls__link" href="/pravila/" target="_blank">
                Пользовательского соглашения
              </a>
              и даю своё согласие на обработку своих персональных данных в соответствии с
              <a class="form-controls__link" href="/politika-obrabotki-pd/" target="_blank">
                Политикой обработки ПД
              </a>
            </checkbox-policy-text>
          </checkbox-control>
        </form-item>
        <form-item>
          <button-control
            size="large"
            native-type="submit"
            :is-block="true"
            :tabindex="5"
            :loading="loading"
            :disabled="loading"
          >
            Зарегистрироваться
          </button-control>
        </form-item>
        <form-item class="_desc _center _no-mb">
          Уже зарегистрированы?
          <button
            type="button"
            class="form-controls__link"
            tabindex="1"
            @click.prevent="changeState('login')"
          >
            Войдите на сайт
          </button>
        </form-item>
      </template>

      <template v-if="isConfirmRecovery">
        <sms-confirm
          ref="smsConfirmRecovery"
          class="_d"
          :phone="phone"
          :show-button-send="false"
          :is-use-new-end-point="true"
          :captcha-options="captchaOptions"
          :captcha-options-v2="captchaOptionsV2"
          @error="catchError"
          @setState="changeState"
          @verified="handlerVerifiedRecovery"
          @updateCaptchaV3="generateCaptcha"
        />
        <div
          ref="recaptchaContainer"
          :class="{'b24-form-item': recaptchaWidget !== null}"
          class="form-controls__recaptcha"
        ></div>
        <form-item class="_desc _center _no-mb">
          Уже зарегистрированы?
          <button
            type="button"
            class="form-controls__link"
            tabindex="1"
            @click.prevent="changeState('login')"
          >
            Войдите на сайт
          </button>
        </form-item>
      </template>

      <template v-if="state === 'forgot'">
        <div
          ref="recaptchaContainer"
          :class="{'b24-form-item': recaptchaWidget !== null}"
        ></div>
        <form-item>
          <button-control
            native-type="submit"
            size="large"
            :is-block="true"
            :tabindex="2"
            :loading="loading"
            :disabled="loading"
          >
            Отправить
          </button-control>
        </form-item>
        <form-item class="_desc _center _no-mb">
          <button
            type="button"
            class="form-controls__link"
            tabindex="3"
            @click.prevent="changeState('login')"
          >
            Войти на сайт
          </button>
        </form-item>
      </template>

      <template v-if="isCart">
        <div class="form-controls__cart-guest">
          <a :href="checkoutLink" class="b24-btn _secondary _large _block">
            <span class="b24-btn__content">
              Оформить заказ как гость
            </span>
          </a>
        </div>
      </template>

      <template v-if="isVisibleBonus">
        <div class="form-controls__column _no-mb">
          <p
            :class="{ '_nmt': isMobile }"
            class="form-controls__item _center _text _mbs"
            v-html="bonusText"
          >
          </p>
          <a
            href="/novie-knigi/"
            class="b24-btn"
          >
            Потратить бонусы
          </a>
        </div>
      </template>

      <template v-if="isVisibleEmailNotification">
        <confirm-email-notification />
      </template>
    </div>
  </form>
</template>

<script>
import {
  Notification,
  ButtonControl,
  InputControl,
  InputPhoneControl,
  CheckboxControl,
  FormItem,
} from '@book24/ui-components';

import debounce from 'lodash/debounce';

import { required, email as emailValidator } from 'vuelidate/lib/validators';

import pushToDataLayer from '@/js/helpers/pushToDataLayer';

import {
  notCyrillic,
  personName,
  fullName,
  firstEmailSymbols,
  checkPhoneForRu,
  checkPhoneForForeign,
  checkCallCenter,
} from '@/js/helpers/vueValidators';
import fieldValidation from '@/js/utils/formsVue/fieldValidation';
import getCountry from '@/js/utils/getCountry';

import useNotifications from '@/js/vue/_composition/useNotifications';
import useRecaptcha from '@/js/vue/_composition/useRecaptcha';
import useEmail from '@/js/vue/_composition/auth/useEmail';
import usePhone from '@/js/vue/_composition/auth/usePhone';

import CheckboxPolicyText from '@/js/vue/CheckboxPolicyText';
import SmsConfirm from '@/js/vue/Auth/SmsConfirm';
import ConfirmEmailNotification from '@/js/vue/ConfirmEmailNotification';
import Icon from '@/js/vue/Icon';

import {
  ERROR_CODE_VERIFY_RECAPTCHA,
  ERROR_CODE_VERIFY_RECAPTCHA_STRING,
  ERROR_CODE_REGISTRATION_EXIST_PHONE,
} from '@/js/utils/constants/constErrorsCode';
import { ISO_CODE_RUSSIA, FORGOT_TEXT } from '@/js/helpers/globalConst';

import {
  userLogin,
  userPasswordRecovery,
} from '@/js/repositories/User';
import userPasswordRecoveryByPhone from '@/js/services/api/passwordRecoveryByPhone';

import user from '@/js/services/api/user';

const TEXT_ERROR = 'Пользователь с таким E-mail уже зарегистрирован.';

export default {
  name: 'AuthM',
  components: {
    FormItem,
    InputControl,
    ButtonControl,
    Notify: Notification,
    CheckboxControl,
    InputPhoneControl,
    Icon,
    SmsConfirm,
    CheckboxPolicyText,
    ConfirmEmailNotification,
  },
  props: {
    showTitle: { type: Boolean, default: false },
    initialState: { type: String, default: 'login' },
    isMobile: { type: Boolean, default: true },
  },
  setup() {
    return {
      ...useNotifications(),
      ...useRecaptcha(),
      ...useEmail(),
      ...usePhone(),
    };
  },
  data() {
    return {
      password: '',
      name: '',
      phone: '',
      submitted: false,
      needProof: false,
      state: this.initialState,
      showPasswordElement: false,
      loading: false,
      isAgreeWithRules: true,
      isAgreeWithData: true,
      isReload: true,
      isPhoneExist: false,
      isShowNotifyNotAuthNewUser: true,
      errorTextPolicy: 'Ознакомьтесь и согласитесь с условиями',
      countryCode: getCountry(),
      checkoutLink: '/personal/order/make/',
      isEditEmail: false,
      captchaOptions: {},
      captchaOptionsV2: {},
      forgotText: FORGOT_TEXT,
    };
  },
  computed: {
    isRegistration() {
      return this.state === 'registration';
    },
    isConfirmRecovery() {
      return this.state === 'confirmRecovery';
    },
    isAuth() {
      return this.state === 'login';
    },
    isRegistrationSuccess() {
      return this.state === 'registration_success';
    },
    isForgot() {
      return this.state === 'forgot';
    },
    // можно ли проверять email
    canCheckEmail() {
      return !this.$v.email.$error && this.$v.email.$dirty && this.isEditEmail;
    },
    isCart() {
      const html = document.querySelector('html');
      const pageType = html.dataset.pageType;
      return pageType === 'Cart';
    },
    title() {
      let title = 'Войти';
      if (this.isForgot) {
        title = 'Восстановление пароля';
      }
      if (this.isRegistration || this.isConfirmRecovery) {
        title = 'Регистрация';
      }
      if (this.isRegistrationSuccess) {
        title = 'Вы успешно зарегистрировались';
      }
      if (this.isVisibleBonus) {
        title = 'Вы успешно зарегистрировались в программе лояльности book24.ru!';
      }
      if (this.isVisibleEmailNotification) {
        title = `Вы успешно зарегистрировались в программе лояльности book24.ru!<br/>
        <strong>100 бонусных рублей</strong> уже на вашем счете.`;
      }
      return title;
    },
    isRus() {
      const countryCode = this.countryCode || ISO_CODE_RUSSIA;
      return countryCode.toLowerCase() === ISO_CODE_RUSSIA.toLowerCase();
    },
    isVisibleEmailNotification() {
      return this.isRegistrationSuccess && this.isAgreeWithData;
    },
    isVisibleBonus() {
      return this.isRegistrationSuccess && !this.isAgreeWithData;
    },
    titleClass() {
      let classString = '';

      classString = this.isVisibleBonus || this.isVisibleEmailNotification
        ? 'form-controls__item _center _text _title-success-m _nmb'
        : 'form-controls__title';

      return classString;
    },
    titleMobileClass() {
      return !this.isVisibleBonus && !this.isVisibleEmailNotification
        ? 'form-controls__success-title'
        : 'form-controls__item _center _nmb';
    },
    bonusText() {
      return '<strong>100 бонусных рублей уже на вашем счете</strong>.';
    },
  },
  watch: {
    canCheckEmail(value, oldValue) {
      if (value && value !== oldValue) {
        this.checkEmail(this.email);
      } else if (!value) {
        this.showPasswordElement = false;
      }
    },
    // слежка за вводом email (чтобы отправить запрос)
    email() {
      this.hideNotify();
    },
    // сбросить при изменении состояния
    state(value, oldValue) {
      this.submitted = false;
      this.$emit('changeState', value);

      if ((value === 'registration' && oldValue === 'login')
        || (value === 'login' && oldValue === 'registration')) {
        setTimeout(() => {
          this.hideNotify();
        }, 3000);
      }

      if (this.isPhoneExist) this.isPhoneExist = false;
    },
    password(value) {
      if (value.length) {
        this.submitted = true;
      }
    },
  },
  validations() {
    const canCheckEmailDomain = debounce(
      async (value, resolve) => {
        try {
          const result = await this.checkEmailDomainHandler(value);
          if (result) this.isEditEmail = true;
          return resolve(result);
        } catch (e) {
          return resolve(false);
        }
      },
      500,
    );

    const schema = {
      email: {
        required,
        emailValidator,
        notCyrillic,
        firstEmailSymbols,
        checkDomain(value) {
          if (value === '') return true;
          if (this.$v.email.required
            && this.$v.email.emailValidator
            && this.$v.email.notCyrillic
            && this.$v.email.firstEmailSymbols && !this.isEditEmail) {
            return new Promise(resolve => canCheckEmailDomain(value, resolve));
          }
          return true;
        },
      },
    };
    let phoneValidations = { required, checkCallCenter };

    switch (this.state) {
      case 'login':
        Object.assign(schema, {
          password: { required },
        });
        break;
      case 'registration':
        if (this.isRus) {
          phoneValidations = { ...phoneValidations, checkPhoneForRu };
        } else {
          phoneValidations = { checkPhoneForForeign, ...phoneValidations };
        }

        Object.assign(schema, {
          name: { personName, fullName, required },
          phone: phoneValidations,
        });
        break;
    }

    return schema;
  },
  methods: {
    showNotifyBlock(type, caption) {
      this.showNotify(type, caption);

      this.$nextTick(() => {
        const el = this.$refs?.notifyBlock?.$el;
        if (el) {
          const containerSelector = this.isMobile ? '.modal__content' : '.v--modal-overlay';
          this.$scrollTo(this.$refs.notifyBlock.$el, {
            offset: -70,
            container: el.closest(containerSelector),
          });
        }
      });
    },
    handlerInputEmail() {
      this.isEditEmail = false;
    },
    /**
     * Валидация
     */
    fieldValidation,
    /**
     * Проверка валидации формы
     */
    validate() {
      this.$v.$touch();

      let agree = true;
      if (this.isRegistration) {
        agree = this.isAgreeWithRules;
      }

      if (!this.$v.$invalid && agree) {
        switch (this.state) {
          case 'registration': {
            this.checkUser();
            break;
          }
          default: {
            this.applyCaptcha();
          }
        }
      }
    },
    /**
     * Проверка на существование учетной записи пользователя
     */
    checkEmail(email) {
      this.addEmailChecking('checkEmail');
      this.showPasswordElement = false;
      this.hideNotify();

      this.checkEmailAvailability(email)
        .then((data) => {
          if (!data) throw new Error(TEXT_ERROR);
          if (this.isRegistration) {
            this.submitted = true;
          } else {
            this.submitted = false;
            this.changeState('registration');
            if (this.isShowNotifyNotAuthNewUser) {
              this.showNotifyBlock('error', 'Пользователя с таким E-mail не существует.');
            }
          }
        })
        .catch((error) => {
          if (error.code && error.code === 'e1420a46-7bf6-44cf-8723-7e57e4925236') {
            this.submitted = false;
            this.showNotifyBlock('error', error.message);
          } else {
            this.submitted = true;
            this.showPasswordElement = true;
            if (this.isRegistration) {
              this.changeState('login');
              this.showNotifyBlock('success', TEXT_ERROR);
            }
          }
        })
        .finally(() => {
          this.removeEmailChecking('checkEmail');
        });
    },
    handlerVerified() {
      this.needProof = false;
      this.registration();
    },
    async handlerVerifiedRecovery(useV2Captcha = false) {
      let captcha;
      if (useV2Captcha === true) {
        captcha = this.captchaOptionsV2;
      } else {
        await this.generateCaptcha('confirmRecovery')
          .then(() => {
            captcha = this.captchaOptions;
          });
      }
      userPasswordRecoveryByPhone({
        PHONE: this.phone,
        ...captcha,
      })
        .then(() => {
          this.changeState('login');
          this.email = '';
          this.password = '';
          this.$v.$reset();
          setTimeout(() => {
            this.showNotifyBlock('success', 'Вам отправлено смс с данными для входа. Введите их и нажмите «Войти»');
          }, 300);
        })
        .catch((e) => {
          this.catchError(e);
        });
    },
    checkPhoneHandler(phone) {
      return this.checkPhoneAvailabilityHandler(phone);
    },
    checkUser() {
      this.isPhoneExist = false;
      this.loading = true;
      this.checkPhoneHandler(this.phone)
        .then((available) => {
          if (available) {
            this.generateCaptcha('verifyPhone')
              .then(() => {
                if (this.isRus) {
                  this.needProof = true;
                  this.$nextTick(async () => {
                    this.hideNotify();
                    await this.$refs.smsConfirm.sendCode();
                    this.loading = false;
                  });
                } else {
                  this.registration();
                }
              });
          } else {
            this.showNotifyBlock('error', 'Пользователь с данным номером телефона уже существует');
            this.isPhoneExist = true;
            this.loading = false;
          }
        })
        .catch((e) => {
          this.showNotifyBlock('error', e);
        });
    },
    /**
     * Регистрация пользователя
     */
    registration() {
      this.loading = true;
      this.hideNotify();
      const [lastName, name, secondName] = this.name.split(' ');

      this.generateCaptcha('register')
        .then(() => user.post({
          name,
          lastName,
          secondName,
          email: this.email,
          phone: this.phone,
          unsubscribed: this.isAgreeWithData ? 0 : 1,
          ...this.captchaOptions,
        }, 'individual'))
        .then(async () => {
          window.location.reload();
        })
        .catch((error) => {
          this.loading = false;
          this.catchError(error);
          if (!this.showTitle) this.$emit('changeScrollTopModal', true);
          this.isPhoneExist = error.code && error.code === ERROR_CODE_REGISTRATION_EXIST_PHONE;
        });
    },
    applyCaptcha() {
      this.recaptchaAction = this.state;
      this.getReRecaptchaToken()
        .then((captchaToken) => {
          this.sendingForm({ captchaToken, captchaVersion: 'rv3' });
        });
    },
    async generateCaptcha(state) {
      this.recaptchaAction = state;
      return this.getReRecaptchaToken()
        .then((captchaToken) => {
          this.captchaOptions = { captchaToken, captchaAction: state, captchaVersion: 'rv3' };
        });
    },
    renderCaptcha() {
      this.renderReCaptcha((captchaToken) => {
        if (this.state === 'confirmRecovery' && this.$refs?.smsConfirmRecovery) {
          this.captchaOptionsV2 = { captchaToken, captchaAction: 'confirmRecovery', captchaVersion: 'rv2' };
          this.generateCaptcha('confirmRecovery');
          if (this.$refs.smsConfirmRecovery.state === 'sendCode') {
            this.$refs.smsConfirmRecovery.sendReceivedCodeMethod(true, this.captchaOptionsV2);
          } else if (this.$refs.smsConfirmRecovery.state === 'sendPasswordToPhone') {
            this.handlerVerifiedRecovery(true);
          } else {
            this.$refs.smsConfirmRecovery.sendCode(true, this.captchaOptionsV2);
          }
        } else if (this.state === 'registration') {
          this.captchaOptionsV2 = { captchaToken, captchaAction: 'confirmRecovery', captchaVersion: 'rv2' };
          if (this.$refs.smsConfirm.state === 'sendCode') {
            this.$refs.smsConfirm.sendReceivedCodeMethod(true, this.captchaOptionsV2);
          } else {
            this.$refs.smsConfirm.sendCode(true, this.captchaOptionsV2);
          }
          this.generateCaptcha('verifyPhone');
        } else {
          this.$v.$touch();

          if (!this.$v.$invalid) {
            this.sendingForm({ captchaToken, captchaVersion: 'rv2' });
          }
        }
      });
    },
    sendingForm({ captchaToken, captchaVersion }) {
      this.loading = true;
      const options = active => ({ captchaToken, captchaAction: active, captchaVersion });
      switch (this.state) {
        case 'login': {
          this.login(options('login'));
          break;
        }
        case 'registration': {
          this.registration();
          break;
        }
        case 'forgot': {
          this.sendPassword(options('forgot'));
          break;
        }
      }
    },
    catchError(e) {
      if (this.recaptchaWidget !== null) {
        this.resetReCaptcha();
      }
      if ((e.message && e.message.includes(ERROR_CODE_VERIFY_RECAPTCHA_STRING))
        || (e.code && e.code === ERROR_CODE_VERIFY_RECAPTCHA)) {
        if (this.recaptchaWidget === null) {
          this.renderCaptcha();
          pushToDataLayer({ event: 'CaptchaNotVerify' });
        }
      } else {
        this.showNotifyBlock('error', e.message ? e.message : e);
      }
    },
    incorrectPhone(message) {
      this.needProof = false;
      this.showNotifyBlock('error', message);
    },
    /**
     * Авторизация пользователя
     */
    login({ captchaToken = '', captchaAction = '', captchaVersion = 'rv3' }) {
      this.loading = true;
      this.hideNotify();

      userLogin({
        login: this.email,
        password: this.password,
        captchaToken,
        captchaAction,
        captchaVersion,
        stickyBasket: 'N',
        remember: 'N',
      })
        .then(async () => {
          this.isAuthorized = true;
          pushToDataLayer({ event: 'Cart auth-window enter' });
          window.location.reload();
        })
        .catch((e) => {
          this.loading = false;
          this.catchError(e);
        });
    },
    /**
     * Восстановление пароля пользователя
     */
    sendPassword({ captchaToken = '', captchaAction = '', captchaVersion = 'rv3' }) {
      this.loading = true;
      this.hideNotify();

      userPasswordRecovery({
        login: this.email,
        captchaToken,
        captchaAction,
        captchaVersion,
      })
        .then(() => {
          this.changeState('login');
          this.showNotifyBlock('success', 'На электронную почту отправлен пароль для входа, введите его и нажмите «Войти»');
        })
        .catch((e) => {
          if (this.recaptchaWidget !== null) {
            pushToDataLayer({ event: 'CaptchaNotVerifyAgain' });
            this.resetReCaptcha();
          }
          if ((e.message && e.message.includes(ERROR_CODE_VERIFY_RECAPTCHA_STRING))
            || (e.code && e.code === ERROR_CODE_VERIFY_RECAPTCHA)) {
            if (this.recaptchaWidget === null) {
              pushToDataLayer({ event: 'CaptchaNotVerify' });
              this.renderCaptcha();
            }
          } else {
            this.showNotifyBlock('error', e.message ? e.message : e);
          }
        })
        .finally(() => this.loading = false);
    },
    changeState(state, isCheckEmail = false) {
      const recaptchaContainer = this.$refs.recaptchaContainer;

      if (this.isPhoneExist) this.isPhoneExist = false;

      if (recaptchaContainer && recaptchaContainer.hasChildNodes()) {
        recaptchaContainer.innerHTML = '';
        this.recaptchaWidget = null;
      }
      this.$nextTick(() => {
        this.state = state;

        if (isCheckEmail && this.canCheckEmail) {
          this.checkEmail(this.email);
        }
      });
    },
    alertRecoverPassClickEvent() {
      this.generateCaptcha('confirmRecovery').then(() => {
        this.hideNotify();
        this.changeState('confirmRecovery');
        setTimeout(() => {
          this.$refs.smsConfirmRecovery.sendCode();
        });
      });
    },
  },
};
</script>
